export const faqTypes = {
    FAQ_IS_LOADING:'FAQ_IS_LOADING',
    GET_FAQ_SUCCESS: "GET_FAQ_SUCCESS",
    GET_FAQ_FAILURE: "GET_FAQ_FAILURE",
  }